<template>

    <v-modal title="Unsubscribe">
        <template #body>
            <v-alert :message="error" />
            <p v-if="!subscription.cancel_at_period_end" class="small">Are you sure you want to cancel your subscription?</p>
            <p v-else class="small">Your subscription ends {{ subscription.current_period_end | date }}</p>
        </template>
        <template #footer>
            <v-button
                btn-label="Cancel"
                size="sm"
                btn-style="white"
                @click.native="cancel">
            </v-button>
            <v-button v-if="!subscription.cancel_at_period_end"
                btn-label="Unsubscribe"
                size="sm"
                btn-style="danger"
                :loading="loading"
                @click.native="deleteSubscription">
            </v-button>
            <div v-else></div>
        </template>
    </v-modal>

</template>

<script>

import CompanyApi from '@api/CompanyApi';

export default {

    props: {
        subscription: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            error: null,
        }
    },

    methods: {

        deleteSubscription() {
            this.loading = true;
            CompanyApi.deleteSubscription(this.$store.getters.company.id)
                .then((response) => {
                    this.loading = false;
                    this.$emit('changed');
                    this.$store.commit('setAlertSuccess', this.$t('message.unsubscribed'));
                    this.$store.commit('showModal', false);
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
